import apiClient from '../../shared/services/apiClient';

/**
 * Admin API wrapper
 *
 * Creates a wrapper around apiClient that automatically prepends /api/admin to URLs.
 * This is used by admin webmail pages (Clusters, Nodes, Domains, Users).
 */

const createAdminApi = () => {
    // Helper to prepend /api/admin to URLs
    const prependAdminPrefix = (url) => {
        if (url.startsWith('/api/admin')) {
            return url;
        }
        if (url.startsWith('/')) {
            return `/api/admin${url}`;
        }
        return `/api/admin/${url}`;
    };

    return {
        get: (url, config = {}) => apiClient.get(prependAdminPrefix(url), config),
        post: (url, data, config = {}) => apiClient.post(prependAdminPrefix(url), data, config),
        put: (url, data, config = {}) => apiClient.put(prependAdminPrefix(url), data, config),
        delete: (url, config = {}) => apiClient.delete(prependAdminPrefix(url), config),
        patch: (url, data, config = {}) => apiClient.patch(prependAdminPrefix(url), data, config),
    };
};

export const adminApi = createAdminApi();
export default adminApi;
